import React from "react";
import PropTypes from "prop-types";
import { get } from "lodash";
import { Typography } from "@mui/material";
import { TimePicker } from "@mui/x-date-pickers/TimePicker"; // Import TimePicker
import { withTranslation } from "react-i18next";

const TimeField = ({
  label = "",
  formik = null,
  name,
  isDisable = false,
  t,
  ...props
}) => {
  const { touched, errors, setFieldValue, setFieldTouched, values } =
    formik || {};

  const isError = !!get(touched, name, "") && !!get(errors, name, "");

  return (
    <div className="mb-1">
      <TimePicker
        label={label}
        className="w-100"
        size="small"
        ampm={false}
        slotProps={{
          textField: {
            size: "small",
            error: isError,
            onBlur: () => setFieldTouched(name, true),
          },
        }}
        value={get(values, name, "") || null}
        onChange={(newValue) => {
          setFieldValue(name, newValue);
        }}
        disabled={isDisable}
        {...props}
      />

      <Typography
        variant="subtitle2"
        className={`${
          isError ? "visible" : "invisible"
        } input-field-error-message`}
        color="error"
      >
        {t(get(errors, name, ""))}
      </Typography>
    </div>
  );
};

TimeField.propTypes = {
  formik: PropTypes.object,
  label: PropTypes.string,
  name: PropTypes.string,
  isDisable: PropTypes.bool,
  t: PropTypes.func,
};

export default withTranslation()(TimeField);
